(() => {
  const cutoff = Date.parse('2026-11-15T03:00:00Z');
  const update = () => {
    document.querySelectorAll('[data-fr-ondas-offer]').forEach(root => {
      // Liquid covers no-JS rendering; this also updates pages kept open at midnight.
      const renderedAt = Number(root.dataset.renderedAt) * 1000 || 0;
      const launched = Math.max(Date.now(), renderedAt) >= cutoff;
      root.querySelectorAll('[data-early]').forEach(el => { el.hidden = launched; });
      root.querySelectorAll('[data-launch]').forEach(el => { el.hidden = !launched; });
      root.querySelectorAll('[data-pack]').forEach(el => { el.textContent = launched ? '89.990' : '69.990'; });
      root.querySelectorAll('[data-pack-usd]').forEach(el => { el.textContent = launched ? '90' : '70'; });
    });
  };
  update();
  if (!window.frOndasOfferTimer) {
    window.frOndasOfferTimer = window.setInterval(update, 1000);
    document.addEventListener('visibilitychange', update);
    document.addEventListener('shopify:section:load', update);
  }
})();
